export default __webpack_public_path__ + "static/media/conceptual_architecture_02.2fff7342.png";